import { FC, useState } from 'react';
import { AppLogoHeader } from 'templates/AppLogoHeader';
import { PageContent } from 'templates/PageContent';
import { Form } from 'templates/Form';
import { useTranslationWithLang } from 'hooks/useTranslationWithLang';
import { AppFooter } from 'templates/AppFooter';
import { TransitionButton } from 'atoms/TransitionButton';
import { Button } from 'atoms/Button';
import { useAuth } from 'hooks/useAuth';
import { useNavigate } from 'react-router-dom';
import { PATHS } from 'commons/paths';

const REFETCH_INTERVAL = 30;

type ParentalConsentResubmittionProps = {
  setIsSubmitted: (isSubmitted: boolean) => void;
  onClickSubmit: () => void;
};
export const ParentalConsentResubmittion: FC<ParentalConsentResubmittionProps> = (props) => {
  const { t: tAuditionForm } = useTranslationWithLang('auditionForm');
  const { t: tCommons } = useTranslationWithLang('commons');
  const { setIsSubmitted, onClickSubmit } = props;
  const [isDisabled, setIsDisabled] = useState(true);
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();
  // 画面表示時と再送信ボタン押下時に一時的に非活性にする
  if (isDisabled) {
    setTimeout(() => setIsDisabled(false), 1000 * REFETCH_INTERVAL);
  }

  const handleOnClickSubmit = () => {
    onClickSubmit();
    setIsDisabled(true);
  };
  return (
    <>
      <AppLogoHeader />
      <PageContent>
        <Form title={tAuditionForm('TU002_086')} id="resubmission-form-title">
          <div className={'flex justify-center items-center flex-col'}>
            <div className={'text-center'} aria-live="polite">
              <p>{tAuditionForm('TU002_087')}</p>
              <p>{tAuditionForm('TU002_088')}</p>
              <p>{tAuditionForm('TU002_089')}</p>

              <p className="mt-4">{tCommons('TU000_093')}</p>
              <p>{process.env.REACT_APP_MAIL_DOMAIN}</p>
            </div>
            <div className={'flex justify-center items-center mt-10'}>
              <TransitionButton
                className="w-[10rem] mr-6"
                label={tAuditionForm('TU002_030')}
                onClick={() => setIsSubmitted(false)}
                aria-label={tAuditionForm('TU002_030')}
              />
              <Button
                className="w-[10rem]"
                label={tAuditionForm('TU002_068')}
                type="submit"
                onClick={handleOnClickSubmit}
                disabled={isDisabled}
                aria-label={tAuditionForm('TU002_068')}
                aria-disabled={isDisabled}
              />
            </div>
            {isAuthenticated && (
              <div className={'flex justify-center items-center'}>
                <Button
                  className="w-[10rem]"
                  label={tAuditionForm('TU002_039')}
                  type="button"
                  onClick={() => navigate(PATHS.MYPAGE)}
                  aria-label={tAuditionForm('TU002_039')}
                />
              </div>
            )}
          </div>
        </Form>
      </PageContent>
      <AppFooter />
    </>
  );
};
